const localizers = {
  'loading.msg': () => `Nalaganje ...`,
  'SASServer.genericError.msg': () => `Strežnika ni mogoče doseči.`,
  'SASReport.genericError.msg': () => `Izbranega poročila ni mogoče naložiti.`,
  'SASReportImage.genericError.msg': () => `Slike poročila ni bilo mogoče naložiti.`,
  'SASReportImage.imageNotSupported.msg': () => `Slike za to vrsto vsebine poročila niso podprte.`,
}
export default localizers;
